(function () {
    'use strict';

    run.admin.pages.accountPlanCheckout = function () {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const propertiesEl = document.getElementById('properties');

        const buttons_get_plan = document.querySelectorAll('.plan_get_new');
        for (let i = 0; i < buttons_get_plan.length; i++) {
            buttons_get_plan[i].addEventListener('click', function(e) {
                getPlan(e.target);
            });
        }

        // Price change
        const priceSelect = document.getElementById('period');
        priceSelect.addEventListener('change', function(e) {
            const containerSubTotal = document.getElementById('price_subtotal').querySelector('.price');
            const containerTotal = document.getElementById('price_total').querySelector('.price');
            const containerDiscount = document.getElementById('price_discount').querySelector('.price');
            
            const selected = priceSelect.options[priceSelect.selectedIndex];
            const price = selected.dataset.price;

            const discount = (price * 0.75);
            containerDiscount.innerHTML = discount;
            containerSubTotal.innerHTML = price;
            containerTotal.innerHTML = price - discount;
        });

        // Cancel normal form submit
        const form = document.getElementById("form_checkout");
        form.addEventListener('submit', function(e) {
            e.preventDefault();
        })

        // Get
        function getPlan(el)
        {
            for (let i = 0; i < buttons_get_plan.length; i++) {
                buttons_get_plan[i].addEventListener('click', function(e) {
                    e.target.setAttribute('disabled', 'disabled');
                });
            }

            el.innerText = el.dataset.textLoading;

            var form_checkout = document.getElementById("form_checkout");
            var data = new FormData(form_checkout);

            axios.post(GlobalRoutes.plan.createNewViaStripe, data)
            .then(function (response) {
                var stripe = Stripe(propertiesEl.dataset.stripeKey);
                stripe.redirectToCheckout({ sessionId: response.data.data.session_id });
            })
            .catch(function (error) {
                new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                for (let i = 0; i < buttons_get_plan.length; i++) {
                    buttons_get_plan[i].addEventListener('click', function(e) {
                        e.target.removeAttribute('disabled');
                    });
                }

                el.innerText = el.dataset.textOriginal;
            });
        }
    };
})();